export default __webpack_public_path__ + "static/media/black-example-icon.394251c4.svg";